export const CCY_SYMBOL = { USD: "$", QAR: "QAR", SAR: "SAR", AED: "AED", KWD: "KWD" };
import { DISPLAY_CURRENCIES } from "./fx";

// The client's chosen display currency. Every USD-denominated total in the app is
// shown in it at the fixed indicative rate; booked balances stay in real currency.
let _display = localStorage.getItem("tharwy_display_ccy") || "USD";
export const setDisplayCurrency = (code) => { _display = code; };
export const displayCurrency = () => _display;

export function fmtNum(v, digits = 2) {
  if (v === null || v === undefined || isNaN(v)) return "0.00";
  return Number(v).toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

export function fmtUSDStrict(v, digits = 2) {
  return `$${fmtNum(v, digits)}`;
}

export function fmtUSD(v, digits = 2) {
  const m = DISPLAY_CURRENCIES.find((c) => c.code === _display) || DISPLAY_CURRENCIES[0];
  if (m.code === "USD") return `$${fmtNum(v, digits)}`;
  const n = fmtNum(Number(v || 0) * m.rate, digits);
  return m.symbol ? `${m.symbol}${n}` : `${n} ${m.code}`;
}

export function fmtCcy(v, ccy, digits = 2) {
  const sym = CCY_SYMBOL[ccy] || "";
  if (ccy === "USD") return `$${fmtNum(v, digits)}`;
  return `${fmtNum(v, digits)} ${sym}`;
}

export function fmtPct(v) {
  const n = Number(v || 0);
  return `${n >= 0 ? "+" : ""}${fmtNum(n, 2)}%`;
}

export function fmtCompact(v) {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1e12) return `$${(n / 1e12).toFixed(2)}T`;
  if (Math.abs(n) >= 1e9) return `$${(n / 1e9).toFixed(2)}B`;
  if (Math.abs(n) >= 1e6) return `$${(n / 1e6).toFixed(2)}M`;
  if (Math.abs(n) >= 1e3) return `$${(n / 1e3).toFixed(1)}K`;
  return `$${fmtNum(n)}`;
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return d.toLocaleDateString();
}

// Verdict wording shown to clients: the API keeps the short codes, the UI says Shariah.
export const VERDICT_LABEL = {
  "Compliant": "Shariah Compliant",
  "Non-Compliant": "Shariah Non-Compliant",
};
export const verdictLabel = (status) => VERDICT_LABEL[status] || status;
